angular.module("vgresiduos").controller("editAccountCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `meus-dados`);
		};
	}
]);
